// BaseButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// Utilities
import { PhotoShape } from 'utilities/Enums';

// CSS
import './BaseButton.css';

// Components
import BaseCover from 'components/basecover/BaseCover';

/**
 * BaseButton
 * 
 * Renders the toggle component for the sidebar switcher.
 * 
 * @param {function} onClick - Click handler for the toggle.
 *  
 *
 * @returns {ReactNode} - BaseButton.
 */
const BaseButton = React.memo(({ onClick, base, isActive = false, isExpired = false }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State

    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (
        <>
            <div
              className="base-button-container"
              style={{
                    backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
                }}
              onClick={onClick}
              onMouseEnter={() => setHovered(true)}
              onMouseLeave={() => setHovered(false)}
            >

                {/* PROFILE WRAPPER */}
                <div className="base-button-profile-photo-wrapper">

                    <BaseCover
                      base={base}
                      borderWidth={0}
                      borderRadius={4}
                      size={20}
                      shape={PhotoShape.SQUARE}
                    />

                </div>

                {/* TITLE WRAPPER */}
                <div className="base-button-title-wrapper">

                    {/* TITLE TEXT */}
                    <div
                      className="base-button-title-text"
                      style={{
                            color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
                }}
                    >
                        {base?.title || 'Space'}
                    </div>

                    {/* EXPIRED BADGE */}
                    {isExpired && (
                        <div
                          className="base-button-expired-badge"
                        >
                            Expired
                        </div>
                    )}

                </div>

                {/* TITLE ARROW */}
                {isActive && (

                    <div
                      className="base-button-title-check"
                      style={{
                            color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
                        }}
                    >
                        ✓
                    </div>
                )}

            </div>

        </>
    );

});

// Dev Tools
BaseButton.displayName = 'BaseButton';

export default BaseButton;
